import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import { Grid, IconButton, Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CircleIcon from '@material-ui/icons/Lens';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import { useGroupData } from 'hooks';
import { GroupColorMap } from 'api';

import { IGroupForm } from '../../types';
import { getGroupHexColor } from '../../helpers';

interface IProps {
  anchorEl: HTMLElement;
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    maxWidth: 176,
  },
  button: {
    padding: 0,
  },
  icon: {
    fontSize: 30,
  },
}));

const ColorPicker: FC<IProps> = ({ anchorEl, onClose }) => {
  const classes = useStyles();
  const { groupColors } = useGroupData();
  const { values, setFieldValue } = useFormikContext<IGroupForm>();

  const hexColor = getGroupHexColor(groupColors, values.color);

  function handleColorChange(groupColor: GroupColorMap) {
    setFieldValue('color', groupColor.group_color);
    onClose();
  }

  function renderColor(groupColor: GroupColorMap) {
    const Icon = groupColor.hex === hexColor ? CheckCircleIcon : CircleIcon;

    return (
      <Grid item key={groupColor.hex}>
        <IconButton className={classes.button} onClick={() => handleColorChange(groupColor)}>
          <Icon className={classes.icon} style={{ color: groupColor.hex }} />
        </IconButton>
      </Grid>
    );
  }

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      classes={{ paper: classes.paper }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}>
      <Grid container spacing={1}>
        {groupColors.map(renderColor)}
      </Grid>
    </Popover>
  );
};

export default ColorPicker;
